import { render, staticRenderFns } from "./LandingCotizaFactoring2.vue?vue&type=template&id=f7ff8b8a&"
import script from "./LandingCotizaFactoring2.vue?vue&type=script&lang=ts&"
export * from "./LandingCotizaFactoring2.vue?vue&type=script&lang=ts&"
import style0 from "./LandingCotizaFactoring2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports